import { VIEWER_SET_SHOW_OVERWRITE_SCAN_MODAL } from '../actions';

export default function setShowOverwriteScanModal(show) {
  return {
    type: VIEWER_SET_SHOW_OVERWRITE_SCAN_MODAL,
    show,
  };
}
